import { render, staticRenderFns } from "./ChooseComplexExercise.vue?vue&type=template&id=29febbd2&scoped=true&"
import script from "./ChooseComplexExercise.vue?vue&type=script&lang=js&"
export * from "./ChooseComplexExercise.vue?vue&type=script&lang=js&"
import style0 from "./ChooseComplexExercise.vue?vue&type=style&index=0&id=29febbd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29febbd2",
  null
  
)

export default component.exports